import Link from '@/update-monitor/Link'
import { useState } from 'react'

import { PlayerRegistrationWarningModal } from '@/components/modal/PlayerRegistrationWarningModal'
import Image from 'next/image'
import { Button } from '../ui/button'

enum EModal {
  None,
  PlayerRegistrationWarning,
}

export const LogiqServiceBanner = (props: {
  challengeId: string
  isChallengeUserWithoutPlan?: boolean
}): JSX.Element => {
  const [modal, setModal] = useState(EModal.None)
  const linkProps = props.isChallengeUserWithoutPlan
    ? {
        pathname: '/web/challenges/[id]/convert',
        query: { id: props.challengeId },
      }
    : {
        pathname: '/web/user-setting/',
        query: { tab: 'payment' },
      }
  return (
    <>
      <div className="flex max-w-[941px] flex-col rounded-2xl bg-water-60 p-[15px] md:flex-row md:gap-5 lg:gap-[34px] lg:px-7 lg:py-5">
        <div className="text-center text-[20px] font-medium leading-normal tracking-widest text-white md:hidden">
          試験に向けてロジックラボで思考力を鍛えませんか？
        </div>
        <div className="mt-[9px] w-full flex-shrink-0 overflow-hidden rounded-2xl bg-basic-bg md:h-[166px] md:w-[326px] lg:ml-[14px] lg:mt-0 lg:h-[208px] lg:w-[416px]">
          <Image
            src="/images/LC_login_labo@2x.png"
            width={346}
            height={208}
            alt=""
            className="inset-0 mx-auto h-full object-contain"
          />
        </div>

        <div className="mt-4 md:mt-0">
          <div className="hidden text-[29px] font-medium leading-normal tracking-widest text-white md:block md:text-[23px] md:leading-[1.2] lg:text-[29px]">
            試験に向けてロジックラボで思考力を鍛えませんか？
          </div>

          <div className="mt-3 w-full px-[16px] md:w-[329px] md:flex-row md:gap-x-[14px] md:px-0 lg:w-[408px]">
            <div className="mb-[13px] w-full text-center lg:mb-[14px]">
              <span className="relative block w-full rounded-[26px] bg-[#F4F7CC] py-[7px] text-[11px] font-medium leading-normal tracking-widest text-[#0E5FAD] lg:py-[8px] lg:text-[13px]">
                夏休み応援キャンペーン実施中!
                <br />
                <span className="text-lg leading-6 lg:text-xl">
                  今なら2ヶ月半額
                </span>
              </span>
            </div>
            <div className="flex w-full flex-col-reverse items-end gap-[14px] gap-y-[18px] md:flex-row md:gap-x-[14px]">
              <Button
                asChild={true}
                variant="light"
                className="h-[42px] w-full bg-basic-bg text-[17px] tracking-wider md:w-[132px] md:px-[12px] lg:w-[180px] lg:px-4"
              >
                <Link href="https://www.sonyged.com/logiq" target="_blank">
                  詳細をみる
                </Link>
              </Button>
              <div className="relative w-full md:w-[188px] lg:w-[214px]">
                {/* Arrow down */}
                <div className="absolute -top-[14px] left-1/2 h-0 w-0 -translate-x-1/2 border-l-[9px] border-r-[9px] border-t-[9px] border-l-transparent border-r-transparent border-t-[#F4F7CC]" />
                <Button
                  asChild={true}
                  variant="secondary"
                  className="h-[42px] w-full bg-[#FAD96F] text-[17px] tracking-wider md:px-[12px] lg:px-4"
                >
                  <Link href={linkProps}>お申し込みはこちら</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PlayerRegistrationWarningModal
        isOpen={modal === EModal.PlayerRegistrationWarning}
        onRequestClose={() => {
          setModal(EModal.None)
        }}
      />
    </>
  )
}
